import React, { Component } from "react";
import { connect } from "react-redux";
import style from "./style.css";
import CSSModule from "react-css-modules";
import { Link } from "react-router";
import $ from "jquery";
import moment from "moment";

import { getUserInfo, getClassInfo, singupClass } from "../../actions";

import ClassAD from "../../component/classAD";
import Button from "../../component/button";
import Title from "../../component/title";

import { Radio } from "antd";
const RadioGroup = Radio.Group;

class ClassFixed extends Component {
  constructor(props) {
    super(props);
    this.state = {
      step: 1,
      classValue: "",
      students: null,
      lesson_id: null,
    };

    props.getUserInfo();

    this.chooseClass = (id, e) => {
      //console.log(id);
      this.setState({
        step: this.state.step + 1,
        classValue: e.target.innerText,
        class_time_id: id,
      });
    };

    this.radioSelect = (e) => {
      this.setState({ students: e.target.value });
    };

    this.radioClick = (name, e) => {
      this.student_name = name;
    };

    this.next = (e) => {
      const student_id = this.state.students;
      const user_id = this.props.userInfo.id;
      const class_time_id = this.state.class_time_id;

      if (this.state.students) {
        this.props
          .singupClass({
            user_id,
            student_id,
            class_time_id,
          })
          .then((res) => {
            if (!res.error) {
              this.props.getUserInfo();
              this.setState({
                step: this.state.step + 1,
              });
            } else {
              alert(res.error.response.body.error.message);
            }
          });
      }
    };
  }
  componentDidMount() {
    this.props.getClassInfo({ class_id: this.props.params.class_id });
  }

  renderTitleByStep(step) {
    const stepMap = ["選擇課程日期", "確認", "報名完成"];
    return <Title styleName={"step-" + step}>{stepMap[step - 1]}</Title>;
  }
  renderRightHalfByStep(step) {
    switch (step) {
      case 1:
        const { classEntity } = this.props;
        const classInfo = classEntity["class_" + this.props.params.class_id];
        if (classInfo && classInfo.class_times) {
          this.classTimeInfo = classInfo.class_times;
          return this.renderClassTimes(classInfo.class_times);
        }
        return null;
      case 2:
        return this.renderConfirm();
      case 3:
        return this.renderFinal();
    }
  }
  renderClassTimes(times) {
    if (times.length === 0) return <p>目前沒有開課資料</p>;
    else {
      return times.map((object, index) => {
        const tillNow = moment().diff(moment(object.end_date), "days");
        if (tillNow >= 0) return null;
        const sign_ups =
          object.class_lessons[object.class_lessons.length - 1].sign_ups;
        const { start, end, week } = this._generateTime(object);

        const fixedArr = sign_ups.filter((object) => {
          return object.type === "fixed";
        });

        if (fixedArr.length >= object.member_limit) {
          return (
            <Button styleName="button full">{`每週${week} ${start}~${end} (固定生已額滿)`}</Button>
          );
        }

        return (
          <Button
            styleName="button"
            onClick={this.chooseClass.bind(this, object.id)}
          >{`每週${week} ${start}~${end}`}</Button>
        );
      });
    }
  }
  renderConfirm() {
    const { classValue } = this.state;
    const { userInfo } = this.props;
    const currentClassTimeInfo = this.classTimeInfo.find((element) => {
      return this.state.class_time_id === element.id;
    });
    console.log(currentClassTimeInfo);
    return (
      <div styleName="step2">
        <p>{classValue}</p>
        <p>每個學生使用課程服務點數{currentClassTimeInfo.cost_point}點</p>
        <br />
        <br />
        <br />
        <p>報名學生：</p>
        <RadioGroup onChange={this.radioSelect}>
          {userInfo &&
            userInfo.students &&
            userInfo.students.map((object, index) => {
              const sign_up_time =
                this.props.studentsEntity["stu_" + object.id].sign_up_status
                  .times;
              if (
                sign_up_time.find((time) => {
                  return time == this.state.class_time_id;
                })
              ) {
                return (
                  <Radio
                    key={index}
                    value={object.id}
                    style={{
                      display: "block",
                      margin: "15px",
                    }}
                    disabled={true}
                  >
                    {object.name} (此學生已報名過)
                  </Radio>
                );
              }

              return (
                <Radio
                  key={index}
                  value={object.id}
                  style={{
                    color: "#333",
                    display: "block",
                    margin: "15px",
                  }}
                  onClick={this.radioClick.bind(this, object.name)}
                >
                  {object.name}
                </Radio>
              );
            })}
        </RadioGroup>
        <Button styleName="confirm" onClick={this.next}>
          確認
        </Button>
      </div>
    );
  }
  renderFinal() {
    const user_type = this.props.userInfo.level == 2 ? "vip" : "normal";

    const currentClassTimeInfo = this.classTimeInfo.find((element) => {
      return this.state.class_time_id === element.id;
    });

    return (
      <div styleName="step2">
        <p>{this.state.classValue}</p>
        <p>每個學生使用課程服務點數{currentClassTimeInfo.cost_point}點</p>
        <br />
        <br />
        <br />
        <p>報名學生：</p>
        <br />
        {/*{ this.state.students.map((key, index) => <p>{key}</p>) }*/}
        {this.student_name}
        <br />
        <br />
        <p>
          上課後扣點 {currentClassTimeInfo.cost_point} 點，​或現場支付{" "}
          {currentClassTimeInfo.cost_point * 250} 元。
        </p>
        {this.props.lastPoints < 3 && (
          <Link to={`/recharge`}>
            <Button styleName="confirm">前往儲值點數</Button>
          </Link>
        )}
      </div>
    );
  }
  render() {
    const { lessons, step } = this.state;
    const { userInfo } = this.props;
    const classInfo =
      this.props.classEntity["class_" + this.props.params.class_id] || {};
    // const user_type = userInfo && userInfo.level === 2 ? 'vip' : 'normal';

    return (
      <div>
        {this.renderTitleByStep(step)}

        <div styleName="container">
          <ClassAD {...classInfo} styleName="left-block" />

          <div styleName="right-block">{this.renderRightHalfByStep(step)}</div>
        </div>
      </div>
    );
  }
  _generateTime(data) {
    return {
      start: data.start_time,
      end: data.end_time,
      week: weekMap[data.day_of_the_week],
    };
  }
}

const weekMap = {
  0: "日",
  1: "一",
  2: "二",
  3: "三",
  4: "四",
  5: "五",
  6: "六",
  7: "日",
};

const mapStateToProps = (state) => {
  return {
    userInfo: state.data.user,
    lastPoints: state.data.lastPoints,
    classEntity: state.data.classEntity,
    lessonEntity: state.data.lessonEntity,
    studentsEntity: state.data.studentsEntity,
  };
};

export default connect(mapStateToProps, {
  getUserInfo,
  getClassInfo,
  singupClass,
})(CSSModule(ClassFixed, style, { allowMultiple: true }));



/** WEBPACK FOOTER **
 ** ./src/container/classFixed/index.js
 **/